import { Component, Element, State, Method, Event, EventEmitter, h, Prop, Host } from '@stencil/core';
import { clickOnElementOrChild } from '../../utils/';

@Component({
  tag: 'zpr-modal'
})
export class ZprModal {
  @Element() modalEl: HTMLElement;

  @Prop() size: 'small' | 'medium' | 'large' = 'small';
  @Prop() url?: string;

  @State() isActive: boolean = false;

  @Event() closed: EventEmitter;
  @Event() opened: EventEmitter;

  @Method()
  async getTriggerOption() {
    if(!this.url) return

    const triggerSettingTabs = this.modalEl.querySelector('#triggerSettingTabs');
    const resp = await fetch(`${this.url}`);
    const body = await resp.text();
    triggerSettingTabs.innerHTML = body;
  }

  @Method()
  async open() {
    if (this.isActive) return;
    this.isActive = true;
    this.opened.emit();
  }

  @Method()
  async close() {
    if (!this.isActive) return;
    this.isActive = false;
    this.closed.emit();
  }

  componentDidLoad() {
    this.modalEl.removeAttribute('hidden')

    this.modalEl.addEventListener('click', e => {
      if (clickOnElementOrChild(this.modalEl.children[0] as HTMLElement, e)) {
        return;
      }
      this.close();
    });

    this.modalEl.querySelectorAll('[data-modal-action="close"]').forEach(el => {
      el.addEventListener('click', ev => {
        ev.preventDefault()
        this.close()
      })
    })

    window.addEventListener('popstate', e => {
      this.close();
    });
  }

  render() {
    return <Host class={[this.size, this.isActive ? 'is-open' : undefined].join(' ')}>
      <div class="modal-content">
        <button type="button" class="zpr-modal-close" onClick={this.close.bind(this)}></button>
        <slot />
      </div>
    </Host>;
  }
}
